var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-item" },
    [
      _c("div", { staticClass: "item" }, [
        _vm._v("\n    " + _vm._s(_vm.$t("apps.payroll.label.name")) + "\n  ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "item wages" }, [
        _vm._v(
          "\n    " + _vm._s(_vm.$t("apps.payroll.label.wageamount")) + "\n  "
        )
      ]),
      _vm._v(" "),
      _vm._l(_vm.insertColumns, function(item, index) {
        return _c("div", { key: index, staticClass: "item insert-column" }, [
          _vm._v("\n    " + _vm._s(item.name) + "\n  ")
        ])
      }),
      _vm._v(" "),
      _c("div", { staticClass: "item net" }, [
        _vm._v("\n    " + _vm._s(_vm.$t("apps.payroll.label.net")) + "\n  ")
      ]),
      _vm._v(" "),
      !_vm.disabled ? _c("div", { staticClass: "item delete" }) : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1e4d9712", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e4d9712","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/BasePaySlipEmployeeHead.vue
// module id = null
// module chunks = 